import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  Comment2Json,
  CommentCollectionJson,
  CommentJson,
} from "../types/comment.type";
import { FileJson } from "common/types/File";
import { baseQuery } from "common/api/BaseQuery";
import Setting from "setting";
import { RootState } from "app/store";

export const fileApi = createApi({
  reducerPath: "commentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: Setting.REACT_APP_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set("Authorization", `${token}`);
        // headers.set(
        //   "Idempotency-Key",
        //   `e9b8c96cb3780d3d0a2b0debf5b72fc4d94c84b6f4e680af9149f46e58a53c7c`
        // );
        headers.set("Accept", `application/json, text/plain, */*`);
        //
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // get
    getFileList: builder.query<any, { getlist_id: string }>({
      query(params) {
        return {
          url: "files/public/getlistfile",
          method: "get",
          params: { getlist_id: params.getlist_id },
        };
      },
    }),

    // post
    postImagePublic: builder.mutation({
      query(body) {
        return {
          url: "/files/public/addpublic",
          method: "post",
          body,
        };
      },
    }),

    deleteImage: builder.mutation<any, { id: number }>({
      query: (data) => ({
        url: `/files/${data.id}`,
        method: "delete",
      }),
    }),
    // deleteImage: builder.mutation({
    //   query(body) {},
    // }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { usePostImagePublicMutation, useDeleteImageMutation } = fileApi;
